import './instrument';
import './datadog';
import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css';
import 'react-tippy/dist/tippy.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
